import { Skeleton, Text, Image, Flex } from "@chakra-ui/react";
import { useQuery } from "@apollo/client";
import { GROUPS_QUERY } from "../../Queries";
import LoaderFullwidth from "../../Helpers/LoaderFullwidth";

type GroupState = {
  id: number;
  name: string;
  preview: string;
};

const Group = (props: GroupState & { add: (id:number) => Promise<void>}) => {
  return (
    <Image
      src={props.preview}
      alt={props.name}
      fallback={<Skeleton w={150} />}
      w={150}
      cursor="pointer"
      onClick={() => props.add(props.id)}
    />
  );
};

const Groups = (props: {
  addGroup: (
    id: number
  ) => Promise<void>;
}) => {
  const { data, loading, error } = useQuery(GROUPS_QUERY);
  if (loading) return <LoaderFullwidth />;
  if (error) return <Text color="red">Ошибка: {error.message}</Text>;
  return (
    <Flex>
      {data &&
        data.groups &&
        data.groups.items.map((group: GroupState) => (
          <Group {...group} key={`group${group.id}`} add={props.addGroup}/>
        ))}
    </Flex>
  );
};
export default Groups;
